/**
 * Wraps an arbitrary value in a Promise so that it can be awaited on
 */
export function asPromise(value) {
    return Promise.resolve(value);
}
//# sourceMappingURL=as-promise.js.map